import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
    IActionType,
    IGetQueryParams,
    IFetchZonalConfigNormalizedResponse,
    ICreateZonalConfigPayload,
    IWarehousePayload,
    IZonalConfigChildZonesResponse,
    IZonalConfigUpdatePayload, IWarehouseStorageBlock,
} from "../../interfaces/Index";
import {
  createZonalConfigApiCall,
  fetchZonalConfigsApiCall,
  fetchZonalConfigWarehouseApiCall,
  getZonalConfigChildZonesApiCall,
  getZonalConfigWarehouseApiCall,
  getZonalConfigWarehouseListWithStorageBlocksApiCall,
  updateZonalConfigApiCall,
  zonalServiceCSVBatchUpdateMultiPartUploadApiCall,
  zonalBoundaryCSVMultiPartUploadApiCall,
  fetchZonalConfigChannelApiCall,
} from "redux/sources/ZonalConfigSource";

export const fetchZonalConfigsListInit = () => ({
  type: actionTypes.GET_ZONAL_CONFIGS_LIST_INIT,
});

export const fetchZonalConfigsListSuccess = (
  payload: IFetchZonalConfigNormalizedResponse | null
) => ({
  type: actionTypes.GET_ZONAL_CONFIGS_LIST_SUCCESS,
  payload,
});

export const fetchZonalConfigsListFail = (error: string | object | null) => ({
  type: actionTypes.GET_ZONAL_CONFIGS_LIST_FAIL,
  error,
});

export const fetchZonalConfigChannelInit = () => ({
  type: actionTypes.GET_ZONAL_CONFIG_CHANNEL_INIT,
});

export const fetchZonalConfigChannelSuccess = (
  payload: string | null
) => ({
  type: actionTypes.GET_ZONAL_CONFIG_CHANNEL_SUCCESS,
  payload,
});

export const fetchZonalConfigChannelFail = (error: string | object | null) => ({
  type: actionTypes.GET_ZONAL_CONFIG_CHANNEL_FAIL,
  error,
});

export const zonalBoundaryConfigUploadInit = () => ({
  type: actionTypes.ZONAL_CONFIG_UPLOAD_INIT,
});

export const zonalBoundaryConfigUploadSuccess = () => ({
  type: actionTypes.ZONAL_CONFIG_UPLOAD_SUCCESS,
});

export const zonalBoundaryConfigUploadFail = (error: string | object | null) => ({
  type: actionTypes.ZONAL_CONFIG_UPLOAD_FAIL,
  error,
});

export const createZonalConfigInit = () => ({
  type: actionTypes.CREATE_ZONAL_CONFIG_INIT,
});

export const createZonalConfigSuccess = () => ({
  type: actionTypes.CREATE_ZONAL_CONFIG_SUCCESS,
});

export const createZonalConfigFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_ZONAL_CONFIG_FAIL,
  error,
});

export const zonalConfigUpdateInit = () => ({
  type: actionTypes.UPDATE_ZONAL_CONFIG_INIT,
});

export const zonalConfigUpdateSuccess = () => ({
  type: actionTypes.UPDATE_ZONAL_CONFIG_SUCCESS,
});

export const zonalConfigUpdateFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_ZONAL_CONFIG_FAIL,
  error,
});

export const clearZonalConfigDetails = () => ({
  type: actionTypes.CLEAR_ZONAL_CONFIG_DETAILS,
});

export const getZonalConfigWareHouseNamesInit = () => ({
  type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_INIT,
});

export const getZonalConfigWareHouseNamesSuccess = (
  payload: Array<IWarehousePayload>
) => ({
  type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_SUCCESS,
  payload,
});

export const getZonalConfigWareHouseNamesFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_FAIL,
  error,
});

export const getZonalConfigChildZonesInit = () => ({
  type: actionTypes.GET_ZONAL_CONFIG_CHILD_ZONES_INIT,
});

export const getZonalConfigChildZonesSuccess = (
  payload: Array<IZonalConfigChildZonesResponse>
) => ({
  type: actionTypes.GET_ZONAL_CONFIG_CHILD_ZONES_SUCCESS,
  payload,
});

export const getZonalConfigChildZonesFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_ZONAL_CONFIG_CHILD_ZONES_FAIL,
  error,
});

export const getZonalConfigTownsInit = () => ({
  type: actionTypes.GET_ZONAL_CONFIG_TOWNS_INIT,
});

export const getZonalConfigTownsSuccess = (
  payload: Array<IZonalConfigChildZonesResponse>
) => ({
  type: actionTypes.GET_ZONAL_CONFIG_TOWNS_SUCCESS,
  payload,
});

export const getZonalConfigTownsFail = (error: string | object | null) => ({
  type: actionTypes.GET_ZONAL_CONFIG_TOWNS_FAIL,
  error,
});

export const getZonalConfigWarehouseNameInit = () => ({
  type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_NAME_INIT,
});

export const getZonalConfigWarehouseNameSuccess = (
  payload: Array<IZonalConfigChildZonesResponse>
) =>{
    return ({
  type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_NAME_SUCCESS,
  payload,
})};

export const getZonalConfigWarehouseNameFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_NAME_FAIL,
  error,
});


export const getZonalConfigWarehouseListWithStorageBlocksInit = () => ({
    type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_INIT,
});

export const getZonalConfigWarehouseListWithStorageBlocksSuccess = (
    payload: Array<IZonalConfigChildZonesResponse>
) => ({
    type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_SUCCESS,
    payload,
});

export const getZonalConfigWarehouseListWithStorageBlocksFail = (
    error: string | object | null
) => ({
    type: actionTypes.GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_FAIL,
    error,
});

export const getZonalConfigsList =
  (cityId: string, queryParams?: IGetQueryParams) =>
    (dispatch: Dispatch<IActionType>) => {
      dispatch(fetchZonalConfigsListInit());
      return fetchZonalConfigsApiCall(cityId, queryParams)
        .then((zonalConfigsList: any) =>
          dispatch(fetchZonalConfigsListSuccess(zonalConfigsList))
        )
        .catch((e: object | null | string) =>
          dispatch(fetchZonalConfigsListFail(e))
        );
    };

//zonal boundaries
export const zonalBoundaryConfigUpload =
  (cityId: string, payload: FormData, url: string) =>
    (dispatch: Dispatch<IActionType>) => {
      dispatch(zonalBoundaryConfigUploadInit());
      return zonalBoundaryCSVMultiPartUploadApiCall(cityId, payload, url)
        .then(() => dispatch(zonalBoundaryConfigUploadSuccess()))
        .catch((e: object | null | string) => dispatch(zonalBoundaryConfigUploadFail(e)));
    };

//zonal service area
export const zonalServiceCSVBatchUpload =
  (payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(zonalBoundaryConfigUploadInit());
    return zonalServiceCSVBatchUpdateMultiPartUploadApiCall(payload)
      .then(() => dispatch(zonalBoundaryConfigUploadSuccess()))
      .catch((e: object | null | string) =>
        dispatch(zonalBoundaryConfigUploadFail(e))
      );
  };

  // Get Zone Channel
  export const getZonalCustomerChannel = (ucId: string) =>
    (dispatch: Dispatch<IActionType>) => {
      dispatch(fetchZonalConfigChannelInit());
      return fetchZonalConfigChannelApiCall(ucId)
        .then((customerChannel: any) => 
          dispatch(fetchZonalConfigChannelSuccess(customerChannel))
        )
        .catch((e: object | null | string) =>
          dispatch(fetchZonalConfigChannelFail(e))
        );
    };

export const createZonalConfig =
  (payload: ICreateZonalConfigPayload) => (dispatch: Dispatch<IActionType>) => {
    dispatch(createZonalConfigInit());
    return createZonalConfigApiCall(payload)
      .then(() => dispatch(createZonalConfigSuccess()))
      .catch((e: object | null | string) => dispatch(createZonalConfigFail(e)));
  };

export const updateZonalConfig =
  (id: string, zoneType: string, payload: IZonalConfigUpdatePayload) =>
    (dispatch: Dispatch<IActionType>) => {
      dispatch(zonalConfigUpdateInit());
      return updateZonalConfigApiCall(id, zoneType, payload)
        .then(() => dispatch(zonalConfigUpdateSuccess()))
        .catch((e: object | null | string) => dispatch(zonalConfigUpdateFail(e)));
    };

export const clearZonalConfigDetailsAction =
  () => (dispatch: Dispatch<IActionType>) => {
    return dispatch(clearZonalConfigDetails());
  };

export const fetchZonalConfigWareHouseNames =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getZonalConfigWareHouseNamesInit());
    return fetchZonalConfigWarehouseApiCall(queryParams)
      .then((wareHouseNames: Array<IWarehousePayload>) =>
        dispatch(getZonalConfigWareHouseNamesSuccess(wareHouseNames))
      )
      .catch((e: object | null | string) =>
        dispatch(getZonalConfigWareHouseNamesFail(e))
      );
  };

export const getZonalConfigChildZonesAction =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getZonalConfigChildZonesInit());
    return getZonalConfigChildZonesApiCall(id)
      .then((zones: any) => dispatch(getZonalConfigChildZonesSuccess(zones)))
      .catch((e: object | null | string) =>
        dispatch(getZonalConfigChildZonesFail(e))
      );
  };

export const getZonalConfigTownsAction =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getZonalConfigTownsInit());
    return getZonalConfigChildZonesApiCall(id)
      .then((zones: any) => dispatch(getZonalConfigTownsSuccess(zones)))
      .catch((e: object | null | string) =>
        dispatch(getZonalConfigTownsFail(e))
      );
  };

export const getZonalConfigWarehouseAction =
  (id: string, zoneType: string, zoneStatus: boolean) =>
    (dispatch: Dispatch<IActionType>) => {
      dispatch(getZonalConfigWarehouseNameInit());
      return getZonalConfigWarehouseApiCall(id, zoneType, zoneStatus)
        .then((warehouseName: any) => {
                dispatch(getZonalConfigWarehouseNameSuccess(warehouseName))
            }
        )
        .catch((e: object | null | string) =>
          dispatch(getZonalConfigWarehouseNameFail(e))
        );
    };
export const fetchZonalConfigWarehouseListWithStorageBlocksAction =
    (id: string, zoneType: string) =>
        (dispatch: Dispatch<IActionType>) => {

            dispatch(getZonalConfigWarehouseListWithStorageBlocksInit());
            return getZonalConfigWarehouseListWithStorageBlocksApiCall(id, zoneType)
                .then((warehouses: any) => {
                        dispatch(getZonalConfigWarehouseListWithStorageBlocksSuccess(warehouses));
                    }
                )
                .catch((e: object | null | string) =>
                    dispatch(getZonalConfigWarehouseListWithStorageBlocksFail(e))
                );
        };
